import { Reveal, SectionLabel } from './Reveal';
import { SERVICES } from '../../data/content';

export const WhatWeDo = () => (
  <section
    id="what-we-do"
    data-testid="what-we-do-section"
    className="relative border-t border-white/5 bg-navy-950 py-24 lg:py-32"
  >
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <SectionLabel>What We Do</SectionLabel>
          <h2 className="mt-6 font-serif text-4xl leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
            Four capabilities, one accountable mandate.
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 border-t border-white/10 md:grid-cols-2">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 2) * 0.1}>
            <div className="group h-full border-b border-white/10 p-8 transition-colors duration-500 hover:bg-navy-900 md:border-r md:odd:border-r lg:p-12 md:[&:nth-child(2n)]:border-r-0">
              <span className="font-serif text-sm text-gold/60">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-4 font-serif text-2xl tracking-tight text-white lg:text-3xl">
                {s.title}
              </h3>
              <p className="mt-4 max-w-md text-base leading-relaxed text-slate-300">
                {s.desc}
              </p>
              <span className="mt-6 block h-px w-0 bg-gold transition-all duration-500 group-hover:w-16" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
